/*
  Minis Launch v2
  1. Launch switch: Minis Hero v2 sets <html data-ml2-state="pre|live"> inline.
     In "Automatic" mode an open page flips to live at the launch time.
  2. Pre-launch notify form: Klaviyo's "klaviyoForms" submit event for this
     form ID pushes dataLayer "minis_notify_signup".
  3. A dataLayer "minis_lp_view" with the state, once per page view.
*/
(() => {
    if (window.QOTTml2) return;
    window.QOTTml2 = true;
    window.dataLayer = window.dataLayer || [];
    const html = document.documentElement;
    const launch = window.QOTTml2Launch || {};

    // 1. flip to live at the launch time
    if (launch.mode === 'auto' && html.getAttribute('data-ml2-state') === 'pre' && !isNaN(launch.at)) {
        const wait = launch.at - Date.now();
        if (wait > 0 && wait < 2147483647) {
            setTimeout(() => {
                html.setAttribute('data-ml2-state', 'live');
                window.dataLayer.push({ event: 'minis_lp_launch_flip' });
            }, wait + 500);
        }
    }

    // 2. Klaviyo notify sign-up
    let sent = false;
    window.addEventListener('klaviyoForms', (e) => {
        const d = (e && e.detail) || {};
        if (d.type !== 'submit' || sent) return;
        const wrap = document.querySelector('[data-ml2-form]');
        if (!wrap) return;
        const formId = (wrap.dataset.formId || '').trim();
        if (formId && d.formId && String(d.formId) !== formId) return;
        sent = true;
        window.dataLayer.push({ event: 'minis_notify_signup', form_id: d.formId || formId });
    });

    // 3. page view with state
    window.dataLayer.push({ event: 'minis_lp_view', minis_state: html.getAttribute('data-ml2-state') || 'live' });
})();
